export default __webpack_public_path__ + "static/media/a011-fsi-02.50738f55.svg";